<script setup lang="ts">
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'DisciplineKanbanLink',
})

defineProps<{
  href: string
}>()
</script>

<template>
  <a
    class="discipline-kanban-link"
    :href="href"
  >
    <AppText
      name="body1"
      color="blue-700"
    >
      Open in kanban
    </AppText>
    <AppIcon
      :icon="faArrowUpRight"
      size="small"
    />
  </a>
</template>

<style scoped lang="scss" src="./DisciplineKanbanLink.scss" />
